import { createContext } from "react";

interface DonorInfoContextProps {
    donorName: string;
    setDonorName: any;
    donorEmail: string;
    setDonorEmail: any;
    donorPhoneNumber: string;
    setDonorPhoneNumber: any;
    donorAddress: string;
    setDonorAddress: any;
    donorCity: string;
    setDonorCity: any;
    donorState: string;
    setDonorState: any;
    donorCountry: string;
    setDonorCountry: any;
    donorZipCode: string;
    setDonorZipCode: any;
    isOrganization: boolean;
    setIsOrganization: any;
    isAnnonymous: boolean;
    isAgreed: boolean;
    setIsagreed: any;
    setIsannonymous: any;
    organizationName: string;


    setOrganizationName: any;
}

const donorInfoContext = createContext<DonorInfoContextProps>({
    donorName: "",
    setDonorName: (name: string) => {
        return;
    },
    donorEmail: "",
    setDonorEmail: (email: string) => {
        return;
    },
    donorPhoneNumber: "",
    setDonorPhoneNumber: (phone_number: string) => {
        return;
    },
    donorAddress: "",
    setDonorAddress: (address: string) => {
        return;
    },
    donorCity: "",
    setDonorCity: (city: string) => {
        return;
    },
    donorState: "",
    setDonorState: (state: string) => {
        return;
    },
    donorCountry: "",
    setDonorCountry: (country: string) => {
        return;
    },
    donorZipCode: "",
    setDonorZipCode: (zipCode: string) => {
        return;
    },
    isOrganization: false,
    setIsOrganization: (isOrganization: boolean) => {
        return;
    },
    isAnnonymous: false,
    setIsannonymous: (isAnnonymous: boolean) => {
        return;
    },
    isAgreed: true,
    setIsagreed: (setIsagreed: boolean) => {
        return;
    },
    organizationName: "",
    setOrganizationName: (organizationName: string) => {
        return;
    },
});

export default donorInfoContext;
